module.exports = __webpack_public_path__ + "img/login-v2.38505921.svg";